// Module
var code = "<div class=\"countdown__wrapper\"> <div class=\"counter\"> <span id=\"days\">0</span><br> Jours </div> <div class=\"counter\"> <span id=\"hours\">0</span><br> Heures </div> <div class=\"counter\"> <span id=\"minutes\">0</span><br> Minutes </div> <div class=\"counter\"> <span id=\"seconds\">0</span><br> Secondes </div> </div> ";
// Exports
module.exports = code;